const caCpFeEnvVars = process.env.caCpFe as unknown as Record<string, string>;

export const config = {
  API_GW_BASE_URL: caCpFeEnvVars.REACT_APP_API_GW_BASE_URL,
  NODE_ENV: caCpFeEnvVars.NODE_ENV,
  APP_REPO: caCpFeEnvVars.APP_REPO,
  APP_BUILD_NUMBER: caCpFeEnvVars.APP_BUILD_NUMBER,
  APP_COMMIT_HASH: caCpFeEnvVars.APP_COMMIT_HASH,
};
